var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0 404.034c0 16.569 13.431 30 30 30h181.808v17.032c0 17.084-13.849 30.934-30.934 30.934h-65.372v30h281.013v-30h-65.922c-17.084 0-30.934-13.849-30.934-30.934v-17.032h182.341c16.569 0 30-13.431 30-30v-16.867h-512z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.502.79-61.447 61.447h61.447z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.751 0h-135.25v92.237h-92.237v208.063h227.486v-300.3zm-46.399 220.972h-134.687v-30h134.687zm0-61.868h-134.687v-30h134.687z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482 61.867h-82.249v268.432h-287.486v-268.432h-82.265c-16.569 0-30 13.431-30 30v265.299h512v-265.299c0-16.568-13.431-30-30-30z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.448756b5bb6190b7fcb959c6b7d4ee75.svg";
export { ForwardRef as ReactComponent };